import { Link } from 'react-router-dom';
import LegalPage, { Section } from './LegalPage';

export default function BettingRulesPage() {
  return (
    <LegalPage
      title="Betting Rules"
      intro="These rules explain how bets are placed, priced, settled and voided on My Bets. They form part of our Terms & Betting Rules."
    >
      <Section heading="Placing a bet">
        <p>
          Select an outcome to add it to your bet slip, enter your stake and confirm. A bet is only
          live once we accept it. The accepted odds are the decimal odds shown at the moment of
          acceptance. Markets may be suspended (for example during a goal or a key moment) and bets
          cannot be placed while a market is suspended.
        </p>
      </Section>

      <Section heading="Singles and multiples">
        <p>
          A single is one selection. An accumulator (multi) combines several selections; all legs must
          win for the bet to win, and the odds are multiplied together. If one leg is voided, that leg
          is priced at 1.00 and the rest of the accumulator stands.
        </p>
      </Section>

      <Section heading="Settlement">
        <p>
          Bets are settled on the official result once confirmed. Winnings (stake × accepted odds) are
          credited to your wallet automatically. We use the official competition result; we are not
          responsible for unofficial or media-reported results.
        </p>
      </Section>

      <Section heading="Voids and abandoned events">
        <p>
          If an event is abandoned, cancelled or postponed beyond a reasonable period, affected bets are
          voided and stakes returned. Bets accepted on a clear (palpable) odds error may be voided and
          re-settled at the correct odds, or stakes returned.
        </p>
      </Section>

      <Section heading="Live / in-play betting">
        <p>
          Odds update in real time during live betting. Because of natural delays, a bet may be placed
          against odds that have just changed; in that case we may reject the bet or accept it at the
          current odds. We will never settle a bet at odds higher than those accepted.
        </p>
      </Section>

      <Section heading="Maximum payouts and limits">
        <p>
          We may apply maximum stake and payout limits per market or per customer. Where a payout would
          exceed an applicable maximum, the payout is capped at that maximum.
        </p>
      </Section>

      <p className="text-sm text-text-muted">
        These rules sit alongside our full{' '}
        <Link to="/terms" className="font-semibold text-primary hover:underline">
          Terms &amp; Betting Rules
        </Link>
        .
      </p>
    </LegalPage>
  );
}
